import { render, staticRenderFns } from "./BracesIcon.vue?vue&type=template&id=bb08415c&"
import script from "./BracesIcon.vue?vue&type=script&lang=js&"
export * from "./BracesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports